import { createRouter, createWebHistory } from "vue-router";
import Dashboard from "../views/Dashboard.vue";
import store from '../store'
import Tables from "../views/Tables.vue";
import Billing from "../views/Billing.vue";
import VirtualReality from "../views/VirtualReality.vue";
import RTL from "../views/Rtl.vue";
import Profile from "../views/Profile.vue";
import Signup from "../views/Signup.vue";
import Signin from "../views/Signin.vue";
import Orders from "../views/Orders.vue";


const routes = [
  {
    path: "/",
    name: "/",
    redirect: "/dashboard-default",
    meta: { requireLogin: true}

  },
  {
    path: "/dashboard-default",
    name: "Dashboard",
    component: Dashboard,
    meta: { requireLogin: true}
  },
  {
    path: "/tables",
    name: "Tables",
    component: Tables,
    meta: { requireLogin: true}
  },
  {
    path: "/billing",
    name: "Billing",
    component: Billing,
    meta: { requireLogin: true}
  },
  {
    path: "/orders",
    name: "Orders",
    component: Orders,
    meta: { requireLogin: true}
  },
  {
    path: "/virtual-reality",
    name: "Virtual Reality",
    component: VirtualReality,
    meta: { requireLogin: true}
  },
  {
    path: "/rtl-page",
    name: "RTL",
    component: RTL,
  },
  {
    path: "/profile",
    name: "Profile",
    component: Profile,
    meta: { requireLogin: true}
  },
  {
    path: "/signin",
    name: "Signin",
    component: Signin,
  },
  {
    path: "/signup",
    name: "Signup",
    component: Signup,
  },
  
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requireLogin) && !store.state.isAuthenticated) {
      next({ name: 'LogIn', query: { to: to.path } });
  } else {
      next()
    }
})

export default router;
